const MARKS = /\p{Diacritic}/gu;
const SPACES = /\s+/u;

const foldedText = (text: string): string => text.normalize('NFD').replace(MARKS, '').toLowerCase().trim();

export const matchingOptions = <O extends { readonly label: string }>(
  options: readonly O[],
  query: string,
): readonly O[] => {
  const words = foldedText(query)
    .split(SPACES)
    .filter((word) => word !== '');
  return words.length === 0
    ? options
    : options.filter((option) => {
        const label = foldedText(option.label);
        return words.every((word) => label.includes(word));
      });
};
